export default [
  'MNPCPESMOV', // MENU PC PES MOVIMENTOS
];
